module.exports = __webpack_public_path__ + "img/flying-freelancers-logo.c9ecd2bb.svg";